import { PhitoRoute, PhitoRoutes } from '../../../phito-core/src/lib/app/app/phito-routes';
import { PermissionAction } from '../../../phito-core/src/lib/modules/administration/role-and-permissions/role-and-permission';

export const SCHULE_ROUTES = {
    dashboard: new PhitoRoute(
        'Dashboard',
        'bar_chart',
        PermissionAction.Ansehen('Schule', 'Dashboard'),
        'dashboard',
        () => ['dashboard'],
        import('./dashboard/schule-dashboard.component').then((m) => m.SchuleDashboardComponent),
    ) satisfies PhitoRoute<[]>,
    schulen: new PhitoRoute(
        'Schulen',
        'school',
        PermissionAction.Ansehen('Schule', 'Schule'),
        'schulen',
        () => ['schulen'],
        import('./schule-overview/schule-overview.component').then((m) => m.SchuleOverviewComponent),
    ) satisfies PhitoRoute<[]>,
    klassenraeume: new PhitoRoute(
        'Klassenräume',
        'meeting_room',
        PermissionAction.Ansehen('Schule', 'Klassenraum'),
        'klassenraeume',
        () => ['klassenraeume'],
        import('./klassenraum-overview/klassenraum-overview.component').then((m) => m.KlassenraumOverviewComponent),
    ) satisfies PhitoRoute<[]>,
    mitarbeiter: new PhitoRoute(
        'Lehrer',
        'group',
        PermissionAction.Ansehen('Schule', 'Mitarbeiter'),
        'mitarbeiter',
        () => ['mitarbeiter'],
        import('./mitarbeiter-overview/mitarbeiter-overview.component').then((m) => m.MitarbeiterOverviewComponent),
    ) satisfies PhitoRoute<[]>,
    beurteilungen: new PhitoRoute(
        'Beurteilungen',
        'fact_check',
        PermissionAction.Ansehen('Schule', 'Beurteilung'),
        'beurteilungen',
        () => ['beurteilungen'],
        import('./beurteilung-overview/beurteilung-overview.component').then((m) => m.BeurteilungOverviewComponent),
    ) satisfies PhitoRoute<[]>,
    beurteilungspunkte: new PhitoRoute(
        'Beurteilungspunkte',
        'list_alt',
        PermissionAction.Ansehen('Schule', 'Beurteilungspunkt'),
        'beurteilungspunkte',
        () => ['beurteilungspunkte'],
        import('./beurteilungspunkt-overview/beurteilungspunkt-overview.component').then(
            (m) => m.BeurteilungspunktOverviewComponent,
        ),
    ) satisfies PhitoRoute<[]>,
    klassenraumtypen: new PhitoRoute(
        'Klassenraumtypen',
        'meeting_room',
        PermissionAction.Ansehen('Schule', 'Klassenraumtyp'),
        'klassenraumtypen',
        () => ['klassenraumtypen'],
        import('./klassenraumtyp-overview/klassenraumtyp-overview.component').then(
            (m) => m.KlassenraumtypOverviewComponent,
        ),
    ) satisfies PhitoRoute<[]>,
    priorities: new PhitoRoute(
        'Prioritäten',
        'priority_high',
        PermissionAction.Ansehen('Schule', 'Priority'),
        'priorities',
        () => ['priorities'],
        import('./priority-overview/priority-overview.component').then((m) => m.PriorityOverviewComponent),
    ) satisfies PhitoRoute<[]>,
    umsetzer: new PhitoRoute(
        'Umsetzer',
        'engineering',
        PermissionAction.Ansehen('Schule', 'Umsetzer'),
        'umsetzer',
        () => ['umsetzer'],
        import('./umsetzer-overview/umsetzer-overview.component').then((m) => m.UmsetzerOverviewComponent),
    ) satisfies PhitoRoute<[]>
} satisfies PhitoRoutes;
